export * from './share.component';



// WEBPACK FOOTER //
// /home/runner/work/power-planner/power-planner/src/app/core.module/share.component/index.ts